const VALID_TABS = new Set(['incomes', 'expenses', 'unassigned', 'assigned']);

export const resolvePaymentsTabFromSearch = (search, fallback = 'incomes') => {
    const fallbackTab = VALID_TABS.has(fallback) ? fallback : 'incomes';
    try {
        const params = new URLSearchParams(search || '');
        const tab = params.get('tab');
        return VALID_TABS.has(tab) ? tab : fallbackTab;
    } catch (error) {
        return fallbackTab;
    }
};

